import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
    faApple,
    faFacebook,
    faInstagram,
    faLinkedin,
    faPinterest,
    faTwitter,
    faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import { faCoin } from "@fortawesome/pro-light-svg-icons";
import {
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAnglesDown,
    faAnglesLeft,
    faAnglesRight,
    faAnglesUp,
    faAngleUp,
    faArrowDown,
    faArrowDownFromLine,
    faArrowLeft,
    faArrowRight,
    faArrowRightArrowLeft,
    faArrowRightFromBracket,
    faArrowsUpDownLeftRight,
    faArrowUp,
    faArrowUpRightFromSquare,
    faArrowUpToLine,
    faBan,
    faBars,
    faBed,
    faBicycle,
    faBolt,
    faBoxArchive,
    faCalendar,
    faCalendarDay,
    faCamera,
    faCheck,
    faChildReaching,
    faCircleArrowDown,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleArrowUp,
    faCircleCheck,
    faCircleExclamation,
    faCircleUser,
    faClock,
    faClockRotateLeft,
    faCoins,
    faComment,
    faCommentPen,
    faComments,
    faCompass,
    faCopy,
    faDogLeashed,
    faDoorClosed,
    faEnvelope,
    faExclamation,
    faFileImage,
    faFileImport,
    faFileLines,
    faFilter,
    faFlagSwallowtail,
    faFloppyDisk,
    faGear,
    faHandHoldingHeart,
    faHeart,
    faHouseChimney,
    faHouseTree,
    faHouseUser,
    faKey,
    faLink,
    faList,
    faListCheck,
    faLocationDot,
    faLockKeyhole,
    faMagnifyingGlass,
    faMap,
    faMinus,
    faPencil,
    faPersonHiking,
    faPhone,
    faPlus,
    faReceipt,
    faReply,
    faReplyAll,
    faRotateLeft,
    faRotateRight,
    faShareNodes,
    faSort,
    faSortDown,
    faSortUp,
    faStar,
    faStarHalf,
    faStopwatch,
    faTag,
    faTrashCan,
    faTreeDeciduous,
    faTriangleExclamation,
    faUser,
    faUserGroup,
    faWaterLadder,
    faWifi,
    faXmark,
} from "@fortawesome/pro-regular-svg-icons";
import {
    faCircleInfo,
    faEllipsis,
    faEllipsisVertical,
    faHeart as faHeartFilled,
    faInfo,
    faLocationCrosshairs,
} from "@fortawesome/pro-solid-svg-icons";
import type { FC, SVGProps } from "react";
import BarsCustom from "@/assets/icon-components/BarsCustom";
import Description from "@/assets/icon-components/Description";
import Euro from "@/assets/icon-components/Euro";
import GoogleCustom from "@/assets/icon-components/Google";
import ImpactLevel1 from "@/assets/icon-components/ImpactLevel1";
import ImpactLevel2 from "@/assets/icon-components/ImpactLevel2";
import ImpactLevel3 from "@/assets/icon-components/ImpactLevel3";
import Leaf from "@/assets/icon-components/Leaf";
import NHMarker from "@/assets/icon-components/NhMarker";
import NoPets from "@/assets/icon-components/NoPets";
import Rotate from "@/assets/icon-components/Rotate";
import Steps from "@/assets/icon-components/Steps";
export type CustomIcon = FC<SVGProps<SVGSVGElement>>;

const faIcons: Record<string, IconDefinition> = {
    deposit: faCoin,
    door: faDoorClosed,
    secure: faLockKeyhole,
    history: faClockRotateLeft,
    arrowRight: faAngleRight,
    arrowLeft: faAngleLeft,
    arrowDown: faAngleDown,
    arrowUp: faAngleUp,
    doubleArrowRight: faAnglesRight,
    doubleArrowLeft: faAnglesLeft,
    doubleArrowUp: faAnglesUp,
    doubleArrowDown: faAnglesDown,
    start: faArrowRightFromBracket,
    directionRight: faArrowRight,
    directionLeft: faArrowLeft,
    directionUp: faArrowUp,
    directionDown: faArrowDown,
    exchange: faArrowRightArrowLeft,
    externalLink: faArrowUpRightFromSquare,
    move: faArrowsUpDownLeftRight,
    block: faBan,
    menu: faBars,
    bed: faBed,
    amenities: faBicycle,
    instantBooking: faBolt,
    archived: faBoxArchive,
    calendar: faCalendar,
    period: faCalendarDay,
    photos: faCamera,
    check: faCheck,
    child: faChildReaching,
    circleDirectionRight: faCircleArrowRight,
    circleDirectionLeft: faCircleArrowLeft,
    circleDirectionUp: faCircleArrowUp,
    circleDirectionDown: faCircleArrowDown,
    success: faCircleCheck,
    circleInfo: faCircleInfo,
    spinner: faSpinnerThird,
    account: faCircleUser,
    error: faCircleExclamation,
    clock: faClock,
    upload: faArrowUpToLine,
    download: faArrowDownFromLine,
    extraCosts: faCoins,
    chat: faComment,
    rate: faCommentPen,
    comments: faComments,
    location: faCompass,
    pets: faDogLeashed,
    mail: faEnvelope,
    exclamation: faExclamation,
    fileImage: faFileImage,
    document: faFileLines,
    filter: faFilter,
    flag: faFlagSwallowtail,
    save: faFloppyDisk,
    settings: faGear,
    charity: faHandHoldingHeart,
    heart: faHeart,
    home: faHouseChimney,
    houses: faHouseTree,
    accountHome: faHouseUser,
    key: faKey,
    connect: faLink,
    list: faList,
    rules: faListCheck,
    search: faMagnifyingGlass,
    map: faMap,
    minus: faMinus,
    edit: faPencil,
    activities: faPersonHiking,
    plus: faPlus,
    receipt: faReceipt,
    reply: faReply,
    replyAll: faReplyAll,
    refresh: faRotateRight,
    share: faShareNodes,
    sort: faSort,
    sortDown: faSortDown,
    sortUp: faSortUp,
    star: faStar,
    starHalf: faStarHalf,
    stopwatch: faStopwatch,
    tag: faTag,
    delete: faTrashCan,
    tree: faTreeDeciduous,
    warning: faTriangleExclamation,
    user: faUser,
    travelParty: faUserGroup,
    swimmingPool: faWaterLadder,
    wifi: faWifi,
    close: faXmark,
    marker: faLocationDot,
    copy: faCopy,
    import: faFileImport,
    undo: faRotateLeft,
    phone: faPhone,
    heartFilled: faHeartFilled,
    tip: faCircleInfo,
    info: faInfo,
    crosshair: faLocationCrosshairs,
    moreVertical: faEllipsisVertical,
    moreHorizontal: faEllipsis,
    facebook: faFacebook,
    instagram: faInstagram,
    linkedin: faLinkedin,
    pinterest: faPinterest,
    twitter: faTwitter,
    whatsapp: faWhatsapp,
    apple: faApple,
};

// make sure to run 'make icons' when adding an icon here
const customIcons: Record<string, CustomIcon> = {
    google: GoogleCustom,
    description: Description,
    euro: Euro,
    leaf: Leaf,
    noPets: NoPets,
    rotate: Rotate,
    steps: Steps,
    bars: BarsCustom,
    impactLevel1: ImpactLevel1,
    impactLevel2: ImpactLevel2,
    impactLevel3: ImpactLevel3,
    nhMarker: NHMarker,
};

const icons = {
    ...faIcons,
    ...customIcons,
};

export type IconType = keyof typeof icons;

export default icons;
